import { createContext } from "react";

const BrowserStorageContext = createContext(localStorage);
export default BrowserStorageContext;
